<template>
    <div>
        <div
            class="flex w-full gap-5 overflow-x-scroll lg:grid lg:grid-cols-5 lg:overflow-visible"
        >
            <template
                v-for="(hotGame, idx) in hotSlotGames.items"
                :key="hotGame.partner_game_id"
            >
                <div v-if="idx < 5" class="w-[202px] flex-none">
                    <ThaCommonGameCard
                        :data="hotGame"
                        :jackpotvalue="findJacpot(hotGame)"
                        @click="handleGetGameUrl(hotGame)"
                    />
                </div>
            </template>
        </div>
    </div>
</template>
<script setup>
import {
    useGamesStore,
    useAlertStore,
    useJackpotStore,
    useUserStore,
    useModalStore,
} from '~/stores'
import { storeToRefs } from 'pinia'

const alertStore = useAlertStore()

const gameStoreInstance = useGamesStore()
const { hotSlotGames } = storeToRefs(gameStoreInstance)
const { getGameUrl, getHotSlotGames } = gameStoreInstance

const useJackpotStoreInstance = useJackpotStore()
const { jackpots } = storeToRefs(useJackpotStoreInstance)
const { isMobile } = useDevice()
const useUserStoreInstance = useUserStore()
const useModalStoreInstance = useModalStore()
const handleGetGameUrl = async (payload) => {
    if (!useUserStoreInstance.isLoggedIn) {
        useModalStoreInstance.showLoginModal = true
        return
    }
    const toSend = {
        partnerProvider: payload.partner_provider,
        partnerGameId: payload.partner_game_id,
    }
    if (isMobile) {
        const newtab = window.open('', '_blank')
        try {
            const { data } = await getGameUrl(toSend)
            if (data?.value?.status === 'OK') {
                const { url } = data.value.data
                if (newtab) newtab.location.href = url
            } else if (data?.value?.data?.url === '') {
                if (newtab) newtab.close()
                // NO URL recieved
                alertStore.showMessageError({
                    value: {
                        statusCode: 'SHOW_MESSAGE',
                        message: t('error.server_is_busy'),
                    },
                })
            } else if (data.value === null) {
                // no auth
                if (newtab) newtab.close()
            }
        } catch (error) {
            if (newtab) newtab.close()
            alertStore.showMessageError(error)
        }
    } else {
        const { data } = await getGameUrl(toSend)
        if (data?.value?.status === 'OK') {
            const { url } = data.value.data
            navigateTo(url, {
                open: {
                    target: '_blank',
                },
            })
        }
    }
}
const findJacpot = (game) => {
    return jackpots.value[game.partner_game_id]
}

// refetch when language changes
const { locale } = useI18n()
watch(
    () => locale.value,
    async (newVal, oldVal) => {
        if (newVal !== oldVal) {
            await getHotSlotGames()
        }
    },
    { immediate: false, deep: false }
)
await getHotSlotGames()
</script>

<style lang="scss" scoped>
:deep() {
    .loader-image {
        background: none !important;
    }
}
</style>
